import { Head } from "@inertiajs/react";
import MarkdownContent from "@/components/markdown-content";
import SectionHeading from "@/components/marketing/section-heading";
import SmartLink from "@/components/marketing/smart-link";
import PublicLayout from "@/layouts/public-layout";
import { companyProfile, siteLinks } from "@/data/marketing-site";

function OrganizationFaq({ faq }) {
  const title = faq.title || `${faq.organization_name}: Vejledning og FAQ`;

  return (
    <>
      <Head title={`${title} · Obsero`} />

      <section className="public-section public-section--white-surface public-faq-hero">
        <div className="public-container public-faq-hero__grid">
          <div>
            <div className="public-faq__eyebrow">{faq.organization_name} · FAQ</div>
            <h1 className="public-faq-hero__title">{title}</h1>
            <p className="public-section__copy public-faq-hero__introduction">
              {faq.introduction || `Her finder du svar på ofte stillede spørgsmål og vejledning fra ${faq.organization_name}.`}
            </p>
          </div>

          <div className="public-faq-cover" aria-hidden="true">
            <span className="public-faq-cover__brand">obsero</span>
            <span className="public-faq-cover__label">Vejledning og svar</span>
            <span className="public-faq-cover__letters">FAQ</span>
            <span className="public-faq-cover__organization">{faq.organization_name}</span>
          </div>
        </div>
      </section>

      <section className="public-section public-section--shell-band">
        <div className="public-container public-faq__grid">
          <aside>
            <div className="public-faq__eyebrow">Ofte stillede spørgsmål</div>
            <SectionHeading
              title="Find det svar, du har brug for."
              copy="Vælg et spørgsmål for at læse svaret."
            />

            <div className="public-faq__contact">
              <h3 className="public-stack-item__title">Stadig i tvivl?</h3>
              <p className="public-section__copy">Kontakt Obsero, hvis du har brug for hjælp eller yderligere vejledning.</p>
              <SmartLink href={siteLinks.contact} className="btn btn-primary mt-3">
                Kontakt Obsero <i className="bi bi-arrow-right ms-3" aria-hidden="true" />
              </SmartLink>
              <SmartLink href={companyProfile.phoneHref} className="d-block mt-3">{companyProfile.phone}</SmartLink>
            </div>
          </aside>

          <div className="public-faq__questions">
            {faq.entries.length === 0 ? (
              <p className="public-section__copy mt-0">Der er endnu ingen spørgsmål og svar. Kontakt os, hvis du har brug for hjælp.</p>
            ) : (
              faq.entries.map((entry, index) => (
                <details key={entry.id} className="public-faq__item">
                  <summary className="public-faq__question">
                    <span className="public-faq__number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
                    <span>{entry.question}</span>
                    <span className="public-faq__toggle" aria-hidden="true" />
                  </summary>
                  <MarkdownContent content={entry.answer} className="public-faq__answer" />
                </details>
              ))
            )}
          </div>
        </div>
      </section>
    </>
  );
}

OrganizationFaq.layout = (page) => <PublicLayout>{page}</PublicLayout>;

export default OrganizationFaq;
